import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Endoscopic DCR Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get safe Endoscopic DCR Surgery in Delhi, India. Learn about tear duct obstruction treatment, procedure, recovery, and cost at MedFirst ENT Centre." />
            <meta name="keywords" content="endoscopic DCR Delhi, tear duct surgery, dacryocystorhinostomy, blocked tear duct treatment, ophthalmology ENT, tear duct specialist" />
            <link rel="canonical" href="https://entdelhi.com/endoscopic-dcr/" />
            <meta property="og:title" content="Endoscopic DCR Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get safe Endoscopic DCR Surgery in Delhi, India. Learn about tear duct obstruction treatment, procedure, recovery, and cost at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
